export class Order {
    id: number;
    reservations: OrderReservation[];
    dishes: OrderDish[];
}

export class OrderReservation {
  idReservation: number;
  dishes: OrderDish[];
}
export class OrderDish {
    dishId: number;
    dishName: string;
    count: number;
    unitPrice: number;
}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/models/order.ts